import { useReactiveVar } from "@apollo/client";
import { useEffect } from "react";
import { Route, Switch, useParams, useRouteMatch } from "react-router-dom";

import ArtifactSidebarRoute from "@apps/artifact-sidebar/artifact-sidebar-route";
import { artifactTypePaths } from "@apps/main/routes-constants";
import { meetingLeftSidePanelDisplayedVar } from "@cache/cache";
import Layout from "@components/layout/layout";
import TopicflowIcon from "@components/topicflow-icon/topicflow-icon";

import MeetingPage from "./components/meeting-page";

const MeetingRoutes = () => {
  const { path } = useRouteMatch();
  const params = useParams<{
    meetingId: string;
  }>();
  const meetingId = parseInt(params.meetingId);
  const meetingLeftSidePanelDisplayed = useReactiveVar(
    meetingLeftSidePanelDisplayedVar,
  );

  useEffect(() => {
    if (
      !meetingLeftSidePanelDisplayed &&
      (path.startsWith("/meetings") || path.startsWith("/calendar"))
    ) {
      meetingLeftSidePanelDisplayedVar(true);
    }
  }, [path, meetingLeftSidePanelDisplayed]);

  return (
    <Layout aria-label="Meeting page" className="bg-white">
      <Switch>
        <Route path={path}>
          <div
            className="absolute inset-0 flex"
            aria-label="Meetings container"
          >
            <div className="relative flex-1 bg-white">
              {meetingId ? (
                <MeetingPage meetingId={meetingId} />
              ) : (
                <div className="flex flex-col items-center justify-center h-full gap-3 p-4">
                  <div className="flex flex-col items-center gap-3 w-[346px]">
                    <TopicflowIcon
                      type="info"
                      className="w-4 h-4 text-gray-400"
                    />
                    <div className="flex flex-col gap-1 items-center w-full">
                      <p className="text-sm font-semibold text-gray-800 text-center">
                        Select a meeting to view its details
                      </p>
                      <p className="text-sm text-gray-500 text-center">
                        You can swap between meetings in this view or choose to
                        open the meeting in a larger view.
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Route>
      </Switch>
      <Route path={`${path}/(${artifactTypePaths})/:artifactId`}>
        <ArtifactSidebarRoute />
      </Route>
    </Layout>
  );
};

export default MeetingRoutes;
